"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionPayoutRequestStatus = void 0;
var CommissionPayoutRequestStatus;
(function (CommissionPayoutRequestStatus) {
    CommissionPayoutRequestStatus["Created"] = "Created";
    CommissionPayoutRequestStatus["Declined"] = "Declined";
    CommissionPayoutRequestStatus["Approved"] = "Approved";
})(CommissionPayoutRequestStatus || (exports.CommissionPayoutRequestStatus = CommissionPayoutRequestStatus = {}));
//# sourceMappingURL=CommissionPayoutRequestStatus.js.map